"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
        onCreate: function() {
          this.state = {
              activeState: false
            };
        },
        onInput: function(input) {
          this.state.activeState = input.active || false;
        },
        onToggle: function() {
          this.emit("change", this.state.activeState = !this.state.activeState);
        }
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/FilterButton.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    Button_template = require("../../components/Button/index.marko"),
    Button_tag = marko_loadTag(Button_template),
    WSAdapt_template = require("../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template);

function render(input, out, __component, component, state) {
  var data = input;

  WSAdapt_tag({
      ns: "col-xl-2 col-lg-3 col-sm-4",
      qs: "col-xl-3 col-lg-4",
      hs: "col-xl-4 col-lg-6",
      class: "p-50",
      renderBody: function(out) {
        Button_tag({
            class: "btn-outline-secondary btn-lg btn-block text-nowrap text-ellipsis",
            activeClass: "btn-secondary btn-lg btn-block",
            state: state.activeState,
            title: Locale(input.label),
            renderBody: function(out) {
              Locale_tag({
                  text: input.label
                }, out, __component, "2");
            }
          }, out, __component, "1", [
          [
            "click",
            "onToggle",
            false
          ]
        ]);
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
